import { render } from "./infoWindow.vue?vue&type=template&id=2484c9fe"
import script from "./infoWindow.vue?vue&type=script&lang=js"
export * from "./infoWindow.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/shoptok-analytics/frontend/live/live_224/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__